import { render, staticRenderFns } from "./FaqAndSupportChannelsTabs.vue?vue&type=template&id=35d6e924&scoped=true"
import script from "./FaqAndSupportChannelsTabs.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportChannelsTabs.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportChannelsTabs.vue?vue&type=style&index=0&id=35d6e924&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d6e924",
  null
  
)

export default component.exports